import { render, staticRenderFns } from "./RIOutClmSum.vue?vue&type=template&id=24d8e948&"
import script from "./RIOutClmSum.vue?vue&type=script&lang=js&"
export * from "./RIOutClmSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports